import React from 'react';
import { observer } from 'mobx-react';

// Translations
import translate from '../Translate.js';

// Components
import * as icons from '../Icons/Icons';
import PolicyEdit from './PolicyEdit';
import Drawer from '../Drawer/Drawer';

const Policies = observer(class Policies extends React.Component {
  componentWillMount() {
    const { PolicyStore } = this.props.store;

    this.state = {
      drawerContent: null,
      drawerOpen: false
    }

    // Get existing cancellation policies
    PolicyStore.getCancellationPolicies();

    // PolicyStore.initCancellationPolicy();
  }

  renderResults() {
    const { translation } = this.props;
    const { PolicyStore, SessionStore } = this.props.store;

    if(!SessionStore.loading && PolicyStore.cancellationPolicies.length === 0) {
      return (
        <div className="cta">
          <strong className="cta__copy">
            {translation.cta.heading}
          </strong>

          <button
            className="cta__btn btn--icn-right"
            onClick={PolicyStore.initCancellationPolicy}
          >
            {translation.cta.button}
            <icons.iconCircleRight className="icon" />
          </button>
        </div>
      )
    } else if(PolicyStore.cancellationPolicies.length > 0) {
      return (
        <div className="wrap wrap--brief">
          {PolicyStore.cancellationPolicies.map(
            (policy) =>
            <PolicyEdit
              key={policy.sid}
              policy={policy.versions[0]}
              policySid={policy.sid}
              {...this.props}
            />
          )}

          <button
            className="block-list__add btn--icn-right"
            onClick={PolicyStore.initCancellationPolicy}
          >
            {translation.cta.button}
            <icons.iconPlus className="icon" />
          </button>
        </div>
      )
    }

    return null;
  }

  render() {
    const { translation } = this.props;

    return(
      <main tabIndex="0" id="main-content" className="page">
        <div className="wrap">
          <header className="page__header">
            <h1 className="page__title">{translation.page_title}</h1>
          </header>

          {this.renderResults()}
        </div>

        <Drawer
          content={this.state.drawerContent}
          isOpen={this.state.drawerOpen}
          parent={this}
          {...this.props}
        />
      </main>
    )
  }
})

export default translate('Policies')(Policies);



// WEBPACK FOOTER //
// ./src/app/components/Policies/Policies.js